module.exports = __webpack_public_path__ + "static/media/home_btc.a28769d3.svg";